<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content d-flex flex-row" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <DrawerHandler is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
                <em-filter-tree
                                ref="emTree"
                                checkEnable
                                :treeNodesBind="treeNodesBind"
                                :entity="modelName"
                                filterState="levelTreeFilter"
                                loadState="levelTreeNodes"
                                textKeys="chineseDescription"
                                :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                                @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            </DrawerHandler>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="sithMesMstProjectPlanTemplateResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          edit-disable
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #left-header>
                                        <em-button type="delete"
                                                custom-label="批量删除"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                @click="deleteBatch()"
                                                :busy="onBachDelete"
                                        >
                                        </em-button>
                                        <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-import"
                                            :disabled= false
                                            custom-label="导入项目计划模板数据"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-b-modal.modal-updateProjectPlan>
                                        </em-button>
                                        <!-- <em-button type="save" custom-icon="fa fa-fw fa-lg fa-trash-alt"
                                        :disabled="actionDisabled('select')"
                                        custom-label="批量删除"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        :busy="onComplete"
                                        :showName="true"
                                        @click="deleteSelectedAndAllChildren()"
                                        confirm-text="确定删除选中项及其所有子项？"
                                    >
                                    </em-button> -->
                                    </template>
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
        <b-modal id="modal-updateProjectPlan" title="导入项目计划模板数据" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
            <b-form-group
            id="machineType"
            label="机型:"
            label-for="input-machineType"
            invalid-feedback="必须选择机型"
        >
                <b-form-select id="input-machineType" v-model="selectedMachineType" :options="machineTypes"
                         required></b-form-select>
            </b-form-group>

            <b-form-group
            id="templateFile"
            label="选择数据源文件:"
            label-for="input-dataFile"
            invalid-feedback="必须选择数据源">
            <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2" :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件" :file-name-formatter="formatNames" accept=".xlsx" required></b-form-file>
            <!-- <p>Selected file:</p>
            <ul>
                <li v-for="(file,index) in files" :key="index">
                    <b>{{file.name}}</b>
                </li>
            </ul> -->
            <!-- <b-button @click="file = null">重新选择</b-button>
            <b-button @click="uploadData()">上传文件</b-button> -->
            </b-form-group>

            <div class="form-check mt-2">
                <input class="form-check-input is-invalid" type="checkbox" value="" id="agreement" aria-describedby="invalidCheckFeedback" required>
                <label class="form-check-label" for="agreement">确认覆盖原始数据</label>
                <div id="invalidCheckFeedback" class="invalid-feedback">请确认</div>
            </div>

            <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">导入</b-button>
          <b-button type="reset" variant="light">取消</b-button>
        </b-row>
        </b-form>
        </b-modal>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-03-03 17:03:40

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";

    export default {
        name: "sithMesMstProjectPlanTemplateLevelTreeListView",
        mixins: [emLevelTreeListMixin,emCommonApiMixin],
        components: {DrawerHandler, EmFilter, EmFilterTree},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                file: null,
                machineTypes: [],
                selectedMachineType:null,
                treeNodesBind: [],
                onComplete:false,
                onBachDelete: false,
            }
        },
        computed: {
            modelName(){
                return 'sithMesMstProjectPlanTemplate'
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"].join(",");
            },
        },
        methods: {
            deleteBatch() {
                this.onBachDelete = true
                let checkedNodes = this.$refs.emTree.getCheckedNodes();
                let tempList = []
                for (let item of checkedNodes) {
                    tempList.push(item.id);
                }
                if (tempList.length === 0) {
                    this.$message.warning("没有选择任何项目计划模板");
                    this.onBachDelete = false;
                    return;
                }
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstProjectPlanTemplate")}/batchDeleteWithSub?ids=${tempList.join(",")}`
                this.$_emApiMixin_delete(url, {})
                    .then(response => {
                        commonViewsUtil.showSuccess(this, "批量删除成功")
                        this.$refs.emListFilter.doQuery()
                        this.getOrderedTreeNodes();
                    }).finally(() => this.onBachDelete = false)
            },
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`
            },
            uploadData() {
                var formData = new FormData();
                for(let i=0;i<this.files.length-1;i++) {
                    formData.append('file'+i,this.files[i]);
                }

                this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    this.$refs.emListFilter.doQuery()
                })
            },
            getMachineTypes() {
                this.$_emApiMixin_findByFilter("sithMesMstMachineType", {})
          .then(data => {
            this.machineTypes = data.map(m => {
              return {value: m.id, text: m.name};
            })
          })
            },
            handleSubmit(event) {
                event.preventDefault()
                var formData = new FormData();
                formData.append('file',this.file);
                formData.append('machineType',this.selectedMachineType);

                this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    this.getOrderedTreeNodes();
                    this.$refs.emListFilter.doQuery()
                })

                 this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateProjectPlan')
                })
            },
            handleReset() {
                this.selectedMachineType = null;
                this.file = null;
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateProjectPlan')
                })
            },
            getOrderedTreeNodes() {
                this.$_emApiMixin_get(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/getOrderedTreeNodes`,false)
                .then(data => this.treeNodesBind = data)
            },
            deleteSelectedAndAllChildren() {
                this.onComplete = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/deleteSelectedAndAllChildren?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "删除成功");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
            }
        },
        mounted() {
            //监听modal的show事件
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
            if (modalId === "modal-updateProjectPlan") {
                this.getMachineTypes()
            }
            })

            this.getOrderedTreeNodes();
        }
    }
</script>